import lscache from "lscache";

import {PROPERTY_CONFIGURATOR_VALUES} from "../../app/constants/storage_keys";
import {propertyConfiguratorSearchFormFields} from "../reducers/property_configurator_reducer";
import {PropertyConfiguratorSearchFormValuesType} from "../types/PropertyConfiguratorSearchFormValuesType";

type SearchFormValuesType = PropertyConfiguratorSearchFormValuesType & {instalment?: number};

export function setPropertyConfiguratorStorageData(values: SearchFormValuesType) {
    const filteredOutUtmParams = filterUtmFromParams(values);

    lscache.set(PROPERTY_CONFIGURATOR_VALUES, {
        ...filteredOutUtmParams
    });
}

export function getPropertyConfiguratorStorageData(): SearchFormValuesType {
    const values = lscache.get(PROPERTY_CONFIGURATOR_VALUES);
    if (values) {
        return filterUtmFromParams(values) || {};
    }
    return {} as SearchFormValuesType;
}

const filterUtmFromParams = (values: SearchFormValuesType) => {
    const valuesKeyArray = Object.keys(values) as (keyof typeof propertyConfiguratorSearchFormFields)[];

    return valuesKeyArray.reduce((acc, key) => {
        if (key.includes("utm_")) {
            return acc;
        }

        return {...acc, [key]: values[key]};
    }, {} as SearchFormValuesType);
};
import lscache from "lscache";

import {PROPERTY_CONFIGURATOR_VALUES} from "../../app/constants/storage_keys";
import {propertyConfiguratorSearchFormFields} from "../reducers/property_configurator_reducer";
import {PropertyConfiguratorSearchFormValuesType} from "../types/PropertyConfiguratorSearchFormValuesType";

type SearchFormValuesType = PropertyConfiguratorSearchFormValuesType & {instalment?: number};

export function setPropertyConfiguratorStorageData(values: SearchFormValuesType) {
    const filteredOutUtmParams = filterUtmFromParams(values);

    lscache.set(PROPERTY_CONFIGURATOR_VALUES, {
        ...filteredOutUtmParams
    });
}

export function getPropertyConfiguratorStorageData(): SearchFormValuesType {
    const values = lscache.get(PROPERTY_CONFIGURATOR_VALUES);
    if (values) {
        return filterUtmFromParams(values) || {};
    }
    return {} as SearchFormValuesType;
}

const filterUtmFromParams = (values: SearchFormValuesType) => {
    const valuesKeyArray = Object.keys(values) as (keyof typeof propertyConfiguratorSearchFormFields)[];

    return valuesKeyArray.reduce((acc, key) => {
        if (key.includes("utm_")) {
            return acc;
        }

        return {...acc, [key]: values[key]};
    }, {} as SearchFormValuesType);
};
